const styles = theme => ({
  root: {
    color: theme.palette.white,
    backgroundColor: '#21C712',
    '&:hover': {
      backgroundColor: '#199a0d',
    },
  },
})

export default styles
